var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-save ph"},[_c('a',{staticClass:"grey link",on:{"click":function($event){$event.stopPropagation();return _vm.printDialog.apply(null, arguments)}}},[_vm._v(" PRINT ")])])}
var staticRenderFns = []

export { render, staticRenderFns }